import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { MemberAvatar } from '@icoach/components/infoCard/';
import { Button } from "@curves/ui-base";
import TakePhotoBox from '@icoach/components/TakePhotoBox';
import useMemberApi from '@apis/useMemberApi';

const MemberAvatarEditor = ({ memberID, memberName, picturePath, membershipStatus }) => {
    const { postMemberAvatarApi } = useMemberApi();
    const [avatarImg, setAvatar] = useState(picturePath);
    const takePhotoBoxRef = useRef(null);

    const uploadAvatarApi = async (memberID, params, file) => {
        let resp = await postMemberAvatarApi(memberID, params);

        if (resp) {
            setAvatar(file.blobSrc);
        }
    };

    const handleUploadAvatar = () => {
        takePhotoBoxRef.current.open();
    };

    const handleFileChange = (files) => {
        const formData = new FormData();
        formData.append('file', files.file);
        uploadAvatarApi(memberID, formData, files);
    };

    useEffect(
        () => {
            setAvatar(picturePath);
        },
        // eslint-disable-next-line
        [picturePath],
    );

    return (
        <>
            <MemberAvatar className="mb-1" src={avatarImg} alt={memberName} width="8" membershipStatus={membershipStatus} />
            <Button size="small" className="p-1" onClick={handleUploadAvatar}>
                編輯頭像
            </Button>
            <TakePhotoBox onFileChange={handleFileChange} ref={takePhotoBoxRef} />
        </>
    );
};

MemberAvatarEditor.propTypes = {
    memberID: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    memberName: PropTypes.string,
    picturePath: PropTypes.string,
    membershipStatus: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default MemberAvatarEditor;
